





import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import TransactionView from "../TransactionView.vue";

Vue.component("TransactionView", TransactionView);
@Component({ name: "TransactionRefund", components: { TransactionView } })
export default class TransactionRefund extends Vue {
  @Prop({ required: true })
  public readonly transaction!: Transaction;
}
